<template>
  <Card class="event-list">
    <template slot="title">
      Events
    </template>
    <template slot="content">
      <div class="list-container">
        <Listbox :options="events" listStyle="max-height: 100%" optionLabel="request_id" v-model="selectedEvent"
               v-on:change="eventChanged">
        <template #option="slotProps">
          <div class="p-grid">
            <div class="p-col-1">
              <i class="pi pi-check-circle icon-success" v-if="slotProps.option.authentication_result === 'Success'"/>
              <i class="pi pi-times-circle icon-failed"
                 v-else-if="slotProps.option.authentication_result !== 'Success'"/>
              <i class="pi pi-question-circle icon-unknown" v-else/>
            </div>
            <div class="p-col-11">
              <span>{{ slotProps.option.timestamp.value }}</span>
              <br/>
              <span>GTIN : {{ slotProps.option.epc.product_id }}</span>
              <br/>
              <span>SN : {{ slotProps.option.epc.serial }}</span>
            </div>
          </div>
        </template>
      </Listbox>
      </div>

    </template>
  </Card>
</template>

<script>
export default {
  name: "EventList",
  props: {
    events: Array
  },
  data() {
    return {
      selectedEvent: null
    }
  },
  methods: {
    eventChanged(event) {
      this.$emit("event-selected", event.value);
    }
  }
}
</script>

<style scoped>
.icon-success {
  color: limegreen;
}

.icon-failed {
  color: red;
}

.icon-unknown {
  color: blue;
}

.event-list {
  height: 100%;
  display:flex;
}

.list-container {
  height: 100%;
  padding-bottom: 25px;
}

::v-deep .p-card-body {
  height: 100%;
  width: 100%;
}

::v-deep .p-card-content {
  height: 100%;
}

::v-deep .p-listbox {
  height: 100%;
}

</style>